
import React from 'react';
import {DashboardContainer} from "../../funcs/utils";

const dump_symbol = sym => {
  const container_style = {
    display: "flex",
    fontFamily: "monospace",
  }
  const label_style = {
    fontSize: "1.2rem",
    margin: "1rem",
    width: "10rem",
  }
  const textarea_style = {
    fontFamily: "monospace",
  }

  const str = JSON.stringify(sym, null, 2);
  const num_lines = str.split("\n").length;
  return (
    <div style={container_style}>
      <div style={label_style}>
        {sym.sym}
      </div>
      <div>
        <textarea rows={num_lines} cols={80} style={textarea_style}>
          { JSON.stringify(sym, null, 2) }
        </textarea>
      </div>
    </div>
  )
}
class SASymbols extends React.Component {

  componentDidMount = () => {
    if (!this.props.symbols.loaded) {
      this.props.loadSymbols();
    }
  }

  render = () => {
    const client = this.props.client;
    const loading = this.props.symbols.loading;

    const new_symbols = this.props.symbols.new_symbols || [];
    const symbols = this.props.symbols.symbols || [];

    return (
      <div className={"img-col"} id={"sa_symbols"}>
        <DashboardContainer
          title={"New Symbols"}
          client={client}
          spinner={loading}>
          <div style={{height: "2rem"}}/>
          { new_symbols.map(dump_symbol) }
        </DashboardContainer>
        <DashboardContainer
          title={"Symbols"}
          client={client}
          spinner={loading}>
          { symbols.map(dump_symbol) }
        </DashboardContainer>
      </div>
    )
  }

}

export { SASymbols };
